<template>
  <div :class="['filter-button-container', active && 'active']" @click="click">
    <i v-if="icon" :class="[icon, 'before-icon']"></i>
    <rich-loading v-if="loading" class="after-icon" />
    <span v-if="title" class="title">{{ title }}</span>
    <span v-if="selectNums" class="select-num">{{ selectNums }}</span>
    <i v-if="afterIcon" :class="[afterIcon, 'after-icon']"></i>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '', // crm-bianzu-6
    },
    afterIcon: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },
    selectNums: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-button-container {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 16px;
  white-space: nowrap;
  height: 72px;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 24px;
  margin-right: 16px;
  vertical-align: top;
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #282b33;

  &.active {
    color: #ff7a45;
    i {
      color: #ff7a45;
    }
  }

  .title {
    font-family: 'DiDiSans-Pro-Regular';
    font-size: 28px;
    text-align: center;
    line-height: 36px;
    padding-left: 16px;
    max-width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .select-num {
    width: 35px;
    height: 35px;
    background: #ff7a45;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #ffffff;
    font-weight: normal;
    margin-left: 15px;
  }

  .before-icon {
    width: 40px;
    height: 40px;
    font-size: 40px;
    font-weight: 500;
    color: #595c66;
  }

  .after-icon {
    display: inline-block;
    padding-left: 16px;
    width: 24px;
    height: 24px;
    font-size: 28px;
    font-weight: 900;
    color: #000;
    padding-right: 16px;
  }
}
</style>
